export const BU_PROPERTY_NAME = 'hs_all_assigned_business_unit_ids';
export const ALL_BUSINESS_UNITS_ID = -1;